module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAATCAMAAAB4HKeYAAAAb1BMVEUAAABnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhnaGhE0YWTAAAAJHRSTlMAHfGsctzWafXs4MnEs6VSPjfPvV1XSyMRDwfor5yUgWIxLSb1NMQOAAAAkklEQVQY03WP1xaDMAxDFQgJq+zR0j3+/xuLFNo37oMjHes4NlaMj13uLt5ATMUnUNS0Q0YtogfQniVT1axBxbf0k+8pYjBdGU5lJ8Jakhbklaya/nCUP8U7Pg/5p/IdAzPnse1gtZmtbUlxh+nCaqruDdRaTaQDgOX299dF5/abLWeIJpHNG2yMESeO+KFPrdQXaGwWB+/H5/UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/gw_address_icon.png
// module id = 10
// module chunks = 1